import './polyfill-for-ie';

import type { IApplicationDefinition } from '@apps-config/app-definition';
import { History } from 'history';
import { loadFeatureFlags } from '@telstra-connect/order-tracker/feature-flags';
import { OrderTrackerAction, trackerReducer } from '@telstra-connect/order-tracker/reducers';
import { Application } from '@applications/order-tracker';
import type { IOrderTrackerState } from '@telstra-connect/order-tracker/state';

loadFeatureFlags();

function getApplication() {
    return Application;
}

function getReducer(): IOrderTrackerState {
    return trackerReducer as unknown as IOrderTrackerState;
}

type TGetSessionDetails = () => { sessionId: string; };

export enum TransactionType {
    TRACKING_SERVICE = 'TRACKING_SERVICE'
}

interface IApplications {
    Platform: {
        isTestCustomer: string[];
    };
}

declare const global: {
    TCONN: {
        getAppRoutingHistory: () => History,
        getSessionDetails: TGetSessionDetails,
        Platform: {
            isSecureAuth: boolean;
            resolveTargetURL: (targetURL: string) => string;
        },
        OrderTracker: {
            GetApplication: () => IApplicationDefinition,
            GetReducers: (state: IOrderTrackerState, action: OrderTrackerAction) => IOrderTrackerState,
        }
    }
    applications: IApplications;
}
global.TCONN = { ...global.TCONN };
global.TCONN.OrderTracker = {
    GetApplication: getApplication,
    GetReducers: getReducer,
};

export default global;
